import {ServerProdApi , ServerProdApidl } from '../../../src/group-cloud/network/ServerBizApi';
import {Mod_Roles} from "./Roles";

export class Mod_Stores {

    public static async getStoreList(data) {

        let url = 'store/crm/list';
        let response = await ServerProdApidl.send(url, data);

        //修改返回
        return response.result;
    }

    public static async getStoreInfo(cid) {

        // let url = 'auth_center/yooz/store/info';
        let url = 'store/listbyids';
        let formData =  {
            storeIds: [cid],
        };
        let response = await ServerProdApidl.send(url, formData);
        // console.log(['listbyids', response]);

        let ret;

        ret = {};

        //修改返回
        if (response.result) {
            ret = response.result[0];
        }

        return ret;

    }

    public static async getUserStores(list) {

        let uid, idx, switches = {};
        let uids = [];

        for (idx = 0; idx < list.length; idx++) {
            uid = parseInt(list[idx].id);
            uids.push(uid);
        }

        // console.log(['uids', uids]);

        let url = 'store/auth_center/yooz/store/get_store_by_uid';
        let formData =  {
            user_ids: uids,
        };
        let response = await ServerProdApidl.send(url, formData);

        //修改返回
        let res_list = response.result;

        // console.log(['res-list', res_list]);

        return res_list;

    }

    public static translateStores(store_list) {

        store_list = store_list || [];

        let idx, ret;

        ret = [];

        for (idx = 0; idx < store_list.length; idx++) {

            ret.push(store_list[idx].name);

        }
        console.log('store_list',store_list)
        return  ret.join(', ');

    }

    public static getMemberWhString(record) {

        let ret = '';

        let roles = [], idx;
        if (record && record.warehouse && record.warehouse.length) {

            for (idx = 0; idx < record.warehouse.length; idx++) {
                roles.push(record.warehouse[idx].name);
            }

            if (roles.length) {
                ret = roles.join(',');
            }
        }

        return ret;

    }


}
